import { Box, Button, Stack } from "@mui/material";
import { Player } from "../../../domain/model/User";
import { useTranslation } from "react-i18next";
import { LoadingView } from "../../component/LoadingView";
import { CustomImageView } from "../../component/CustomImageView";
import { APP_BG_IMAGE } from "../../../data/constant/Constants";
import { COLOR_MAIN } from "../../../data/colors/Colors";
import useWindowDimensions from "../../../core/utils/UseWindowDimensions";
import { CustomButtonView } from "../../component/CustomButtonView";
import { CustomPopoverView } from "../../component/CustomPopoverView";
import { useState } from "react";
import InstagramLogo from "../../../assets/images/instagram_logo.png";
import { NewGameView } from "../newGame/NewGameView";
import { CustomTextView } from "../../component/CustomTextView";
import { useNavigate } from "react-router-dom";
import { openLink } from "../../../core/utils/Utils";
import {
  Coordinate,
  RandomCharacterSpawner,
} from "../../component/RandomCharacterSpawner";

export function PlayView({ player }: { player: Player | undefined }) {
  const { t } = useTranslation();

  const { width, height } = useWindowDimensions();
  const isMobile = width < 700 || height < 700;

  const [anchorElPosition, setAnchorElPosition] = useState<{
    top: number;
    left: number;
  } | null>(null);

  const [clickType, setClickType] = useState(1);

  const [popoverContentHeight, setPopoverContentHeight] = useState("auto");

  const DESKTOP_ALLOWED_SPOTS: Coordinate[] = [
    { top: "2%", right: "30%" },
    { top: "2%", left: "30%" },
    { top: "30%", left: "20%" },
    { top: "30%", right: "20%" },
    { bottom: "2%", right: "30%" },
    { bottom: "2%", left: "30%" },
  ];
  const MOBILE_ALLOWED_SPOTS: Coordinate[] = [
    { top: "10%", right: "15%" },
    { top: "10%", left: "15%" },
    { top: "45%", left: "2%" },
    { top: "45%", right: "2%" },
    { bottom: "5%", right: "15%" },
    { bottom: "5%", left: "15%" },
  ];
  return (
    <Stack>
      {!player ? (
        <LoadingView />
      ) : (
        <Stack
          width={"100%"}
          minHeight={"90vh"}
          p={isMobile ? 0 : 4}
          pt={isMobile ? 2 : 3}
          justifyContent={"space-between"}
          alignItems={"center"}
          position={"relative"}
          spacing={2}
        >
          <Box />
          <Stack
            width={isMobile ? (width / height > 2 ? "50vw" : "100vw") : "75vw"}
            alignItems={"center"}
            position={"relative"}
            spacing={1}
          >
            <CustomImageView
              width={"100%"}
              height={380}
              src={APP_BG_IMAGE}
              scale={"cover"}
            />
            <CustomButtonView
              text={t("start_new_game")}
              fontSize="body1"
              props={{ pt: 0.5, pb: 0.5, pr: 2, pl: 2 }}
              onClick={(e) => {
                setClickType(1);
                setAnchorElPosition({
                  top: e.clientY,
                  left: e.clientX,
                });
              }}
            />

            <Stack width={"100%"} alignItems={"center"} pt={2}>
              <Stack
                direction={"row"}
                alignItems={"center"}
                spacing={1}
                sx={{ direction: "ltr" }}
              >
                <CustomImageView width={40} height={40} src={InstagramLogo} />
                <Button
                  onClick={() =>
                    openLink("https://instagram.com/bhc_qatar", "_blank")
                  }
                  sx={{ textTransform: "none", p: 0, borderRadius: 12 }}
                >
                  <CustomTextView
                    text={"@bhc_qatar"}
                    variant="h6"
                    fontWeight="bold"
                    textColor={COLOR_MAIN}
                  />
                </Button>
              </Stack>
            </Stack>
          </Stack>

          <Box />
          <RandomCharacterSpawner
            allowedLocations={
              isMobile ? MOBILE_ALLOWED_SPOTS : DESKTOP_ALLOWED_SPOTS
            }
          />
        </Stack>
      )}

      <CustomPopoverView
        onClose={() => {
          setAnchorElPosition(null);
        }}
        anchorElPosition={anchorElPosition}
        width={
          isMobile
            ? width
            : isMobile
              ? width / height > 2
                ? "100%"
                : "30vw"
              : "28vw"
        }
        height={
          clickType == 2
            ? "100%"
            : isMobile
              ? width / height > 2
                ? "100%"
                : popoverContentHeight
              : popoverContentHeight
        }
        layout={
          <>
            {player && (
              <>
                {clickType == 1 && (
                  <>
                    <NewGameView
                      handleClose={() => setAnchorElPosition(null)}
                      handleHeightChanged={(h) => {
                        setPopoverContentHeight(h);
                      }}
                      player={player}
                      shouldChooseCategoryDirectly={true}
                    />
                  </>
                )}
              </>
            )}
          </>
        }
      />
    </Stack>
  );
}
